import Cookies from 'js-cookie';

import { STORE_COOKIE_NAME } from '../constants';

const ONE_YEAR_IN_DAYS = 60 * 60 * 24 * 365; // setting max age to 1 year

export const setStoreCookie = (storeId: string) => {
    // remove old cookie for full domain name
    Cookies.remove(STORE_COOKIE_NAME);

    const isUS =
        window.location.hostname.includes('.petsmart.com') || window.location.hostname.includes('www.petsmart.com');
    const isCA =
        window.location.hostname.includes('.petsmart.ca') || window.location.hostname.includes('www.petsmart.ca');

    Cookies.set(STORE_COOKIE_NAME, storeId, {
        ...(isUS && { domain: '.petsmart.com' }),
        ...(isCA && { domain: '.petsmart.ca' }),
        expires: ONE_YEAR_IN_DAYS,
        secure: true,
        sameSite: 'Strict' as const,
    });
};

export const removeStoreCookie = () => {
    const isUS =
        window.location.hostname.includes('.petsmart.com') || window.location.hostname.includes('www.petsmart.com');
    const isCA =
        window.location.hostname.includes('.petsmart.ca') || window.location.hostname.includes('www.petsmart.ca');

    // remove old cookie for full domain name
    Cookies.remove(STORE_COOKIE_NAME);
    Cookies.remove(STORE_COOKIE_NAME, {
        ...(isUS && { domain: '.petsmart.com' }),
        ...(isCA && { domain: '.petsmart.ca' }),
    });
};
